import { React, useState, useEffect } from "react";
import { TableBody, TableCell, TableHead, TableSortLabel } from "@mui/material";
import { Select, MenuItem } from "@mui/material";
import {
	StyledTable,
	TableWrapper,
	TableButton,
	StyledTableRow,
	StyledCheckbox,
	TableToolbar,
	StyledTablePagination,
} from "../../components/DataTable/DataTable.styles";
import { getFormattedAmount } from "../../utils/AmountUtils";
import { formatDateString } from "../../utils/DateUtils";
import DeleteIcon from "../../assets/icons/deleteIcon.svg";
import AddIcon from "../../assets/icons/addIcon.svg";
import { Link } from "react-router-dom";
import ConfirmModal from "../../components/ConfirmModal";
import Parse from "../../api/ApiConfig";
import { toast } from "react-toastify";
import Tooltip from "@mui/material/Tooltip";
import { canPerformAction } from "../../utils/UserAuth";
import { AiFillCheckCircle } from "react-icons/ai";
import { approveMultipleProduct } from "./ProductUtils/utils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../redux/AppSlice";
import { getSessionToken } from "../../utils/Utils";

// import { useNavigate,} from "react-router";

/* eslint-disable react/prop-types */
function ProductsDataTable({
	tableData,
	headCells,
	type,
	ProductList,
	orderHistoryList,
	dateFilter,
	handleDateFilterChange,
	// category,
}) {
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [selected, setSelected] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [approveModal, setApproveModal] = useState(false); //temporary fix, should be refatored so all actions can use one modal
	const dispatch = useDispatch();

	// const [loading, setLoading] = useState(true);

	useEffect(() => {
		// Resetting the table data when the tableData prop changes
		setSelected([]);
		setPage(0);
		setOrder("asc");
		setOrderBy("");
	}, [tableData]);
	const getVisibleRows = () => {
		function descendingComparator(a, b, orderBy) {
			if (b[orderBy] < a[orderBy]) {
				return -1;
			}
			if (b[orderBy] > a[orderBy]) {
				return 1;
			}
			return 0;
		}

		function getComparator(order, orderBy) {
			return order === "desc"
				? (a, b) => descendingComparator(a, b, orderBy)
				: (a, b) => -descendingComparator(a, b, orderBy);
		}

		return tableData.slice().sort(getComparator(order, orderBy));
	};

	const visibleRows = getVisibleRows().slice(
		page * rowsPerPage,
		page * rowsPerPage + rowsPerPage
	);

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleClick = (e, id) => {
		// console.log(id);
		// setListOfData((prevData) => {
		// 	return [...prevData, id];
		// });

		const selectedRow = tableData.find((row) => row.id === id);
		const selectedIndex = selected.findIndex(
			(row) => row.id === selectedRow.id
		);

		if (selectedIndex === -1) {
			setSelected((prevSelected) => [...prevSelected, selectedRow]);
		} else {
			setSelected((prevSelected) => [
				...prevSelected.slice(0, selectedIndex),
				...prevSelected.slice(selectedIndex + 1),
			]);
		}
	};

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			const newSelected = tableData.map((row) => row);
			setSelected(newSelected);
			return;
		}
		setSelected([]);
	};

	const handleChangePage = (e, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (e) => {
		setRowsPerPage(+e.target.value);
		setPage(0);
	};

	const handleDeleteAction = () => {
		setConfirmModal(false);
		handleDeleteData(selected);
	};

	//bulk product / order delete
	const handleDeleteData = async (selected) => {
		if (selected.length <= 0) {
			toast.error("item not found!");
			return;
		}
		let currentData = "";
		if (type === undefined || type === "productList") {
			currentData = "Products";
		} else {
			currentData = "Orders";
		}
		// setLoading(true);
		const Objects = selected.map((item) => {
			const Obj = new Parse.Object(currentData);
			Obj.id = item.id;
			return Obj;
		});

		// console.log(Objects);
		Parse.Object.destroyAll(Objects)
			.then(() => {
				if (currentData === "Products") {
					ProductList();
				} else if (currentData === "Orders") {
					orderHistoryList();
				}
				console.log(`${currentData} Objects deleted successfully`);
				toast.success(`${currentData} deleted successfully`);
			})
			.catch((error) => {
				console.log(`Error while deleting ${currentData}`, error);
				toast.error(`Error deleting ${currentData}`);
			});
	};

	//approve product //handle approval
	const handleApproval = async () => {
		dispatch(setLoadingState(true));
		if (selected.length <= 0) {
			toast.error("product not found!");
			dispatch(setLoadingState(false));
			return;
		}
		setApproveModal(false);
		const selectedIds = selected.map((product) => {
			return product.id;
		});
		//
		let data = await approveMultipleProduct(selectedIds, getSessionToken());
		try {
			if (data.result) {
				dispatch(setLoadingState(false));
				toast.success("Product(s) status updated successfully!");
				ProductList(); //call updated table data
			} else {
				dispatch(setLoadingState(false));
				console.log(data);
				toast.error("unable to approve product(s), please try again later");
			}
		} catch (error) {
			dispatch(setLoadingState(false));
			console.log(error);
			toast.error("unable to approve product(s), please try again later");
		}
	};

	//table sort and paginator
	return (
		<>
			<TableToolbar display='flex'>
				<div className='_buttons'>
					{type === undefined || type === "productList" ? (
						<>
							<Link to='addProducts'>
								<TableButton display='flex' variant='outlined' color='error'>
									<img src={AddIcon} alt='' />
									<p>Add product</p>
								</TableButton>
							</Link>
							{canPerformAction("edit", "products") && (
									<TableButton
										onClick={() => setApproveModal(true)}
										display='flex'
										variant='outlined'
										color='primary'
										disabled={selected.length <= 0}
									>
										<AiFillCheckCircle size={24} />
										<p>Approve product</p>
									</TableButton>
							)}
						</>
					) : null}
					<Select
						value={dateFilter}
						className='toolbarSelect'
						onChange={(e) => handleDateFilterChange(e)}
					>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>
					{canPerformAction("delete", "products") &&
						(type === "cart" || type === "customers" ? null : (
							<Tooltip title='Delete' arrow>
								<TableButton
									onClick={() => setConfirmModal(true)}
									variant='outlined'
									color='error'
								>
									<img src={DeleteIcon} alt='' />
								</TableButton>
							</Tooltip>
						))}
				</div>
			</TableToolbar>

			<TableWrapper>
				{confirmModal && (
					<ConfirmModal
						confirmModal={confirmModal}
						setConfirmModal={setConfirmModal}
						content={{
							title: `Delete ${
								type === "productList" || !type ? "Product" : "Order"
							}`,
							desc: `Are you sure you want to delete these ${
								type === "productList" || !type ? "Product(s)" : "Order"
							}(s)`,
							btnText: "Yes, Delete",
						}}
						handleDeleteAction={handleDeleteAction}
					/>
				)}
				{approveModal && (
					<ConfirmModal
						confirmModal={approveModal}
						setConfirmModal={setApproveModal}
						content={{
							title: "Approve Product",
							desc: "Are you sure you want to approve these product(s)?",
							btnText: "Yes, Approve",
						}}
						handleDeleteAction={handleApproval}
					/>
				)}
				<StyledTable sx={{ minWidth: 650 }}>
					<TableHead>
						<StyledTableRow>
							<TableCell padding='checkbox'>
								<StyledCheckbox
									color='default'
									checked={
										selected.length === tableData.length &&
										tableData.length !== 0
									}
									onChange={(e) => handleSelectAll(e)}
									inputProps={{ "aria-labelledby": "Select All" }}
								/>
							</TableCell>

							{headCells.map((headerCell) => (
								<TableCell
									key={headerCell.field}
									align='left'
									sx={{ minWidth: headerCell.width }}
								>
									<TableSortLabel
										active={orderBy === headerCell.field}
										onClick={() => handleRequestSort(headerCell.field)}
										direction={orderBy === headerCell.field ? order : "asc"}
									>
										{headerCell.title}
									</TableSortLabel>
								</TableCell>
							))}
						</StyledTableRow>
					</TableHead>

					<DataTableBody
						selected={selected}
						visibleRows={visibleRows}
						handleClick={handleClick}
						headCells={headCells}
					/>
				</StyledTable>
			</TableWrapper>

			<StyledTablePagination
				rowsPerPageOptions={[5, 10, 25, 100]}
				component='div'
				count={tableData.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</>
	);
}

function DataTableBody({ selected, visibleRows, handleClick, headCells }) {
	const isSelected = (id) => selected.findIndex((row) => row.id === id) !== -1;

	const TableRowItem = ({ row, headerCell }) => {
		if (headerCell.field === "typeProduct") {
			return (
				<TableButton
					component={Link}
					variant='outlined'
					size='small'
					to={`/products/${row.category}/${row.id}`}
				>
					View
				</TableButton>
			);
		}

		if (headerCell.field === "typeOrder") {
			return (
				<TableButton
					component={Link}
					variant='outlined'
					size='small'
					to={`/products/orders/${row.id}`}
				>
					View
				</TableButton>
			);
		}

		if (headerCell.field === "typeCustomer") {
			return (
				<TableButton
					component={Link}
					variant='outlined'
					size='small'
					to={`/customer/${row.objectId}/general`}
				>
					View Profile
				</TableButton>
			);
		}

		const timeFields = ["createdAt", "lastPurchase"];
		if (timeFields.includes(headerCell.field)) {
			return (
				<span className={headerCell.field}>
					{formatDateString(row[headerCell.field])}
				</span>
			);
		}

		if (headerCell.field === "amount") {
			return (
				<span className={headerCell.field}>
					{getFormattedAmount.format(row.amount)}
				</span>
			);
		}

		if (headerCell.field === "total") {
			return (
				<span className={headerCell.field}>
					{getFormattedAmount.format(row.total)}
				</span>
			);
		}

		if (headerCell.field === "value") {
			return (
				<span className={headerCell.field}>
					{getFormattedAmount.format(row.value)}
				</span>
			);
		}

		if (headerCell.field === "approve") {
			const status = row[headerCell.field] ? row[headerCell.field] : false;

			switch (status) {
				case true:
					return <span className='badge approved'>Approved</span>;
				case false:
					return <span className='badge pending'>Pending</span>;
				default:
					return <span className='badge pending'>Pending</span>;
			}
		}

		if (headerCell.field === "saleStatus") {
			const status = row[headerCell.field] ? row[headerCell.field] : "";

			switch (status) {
				case "SUCCESSFUL":
					return <span className='badge complete'>{status}</span>;
				case "RETURNED":
					return <span className='badge returned'>{status}</span>;
				default:
					return <span className='badge deactivated'>{status}</span>;
			}
		}

		if (headerCell.title === "PRODUCT IMAGE") {
			return (
				<div className='img_container'>
					<img
						style={{
							height: "70px",
							width: "70px",
							objectFit: "cover",
						}}
						className=''
						src={row.image}
						alt='product image'
					/>
				</div>
			);
		}

		return (
			<span className={headerCell.field}>
				{row[headerCell.field] ? row[headerCell.field] : "---"}
			</span>
		);
	};

	//table body/data
	return (
		<TableBody>
			{visibleRows.map((row) => {
				const isItemSelected = isSelected(row.id);
				return (
					<StyledTableRow
						hover
						key={row.id}
						onClick={(e) => handleClick(e, row.id)}
						role='checkbox'
						selected={isItemSelected}
					>
						<TableCell padding='checkbox'>
							<StyledCheckbox
								color='default'
								checked={isItemSelected}
								inputProps={{ "aria-labelledby": row.id }}
							/>
						</TableCell>

						{headCells.map((headerCell) => (
							<TableCell key={headerCell.field} align='left'>
								<TableRowItem row={row} headerCell={headerCell} />
							</TableCell>
						))}
					</StyledTableRow>
				);
			})}

			{visibleRows.length === 0 && (
				<StyledTableRow>
					<TableCell
						colSpan={headCells.length + 1}
						align='center'
						className='no_data_found'
					>
						NO DATA FOUND
					</TableCell>
				</StyledTableRow>
			)}
		</TableBody>
	);
}

export default ProductsDataTable;
